module.exports = __webpack_public_path__ + "static/media/about_habby.5df199eb.png";